import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { LoadingReducerState } from "@/app_redux/reducers/reducer_interface";

export const useLoaderActions = (loadingKey: keyof LoadingReducerState) => {
  const dispatch = useAppDispatch();

  const enable = () => {
    dispatch(
      setLoading({
        key: loadingKey,
        status: true,
      }),
    );
  };

  const disable = () => {
    dispatch(
      setLoading({
        key: loadingKey,
        status: false,
      }),
    );
  };

  return { disable, enable };
};
